<p>user-interaction-dialog works!</p>
